{{#if required}}
<dt class="required">
{{else}}
<dt class='optional'>
{{/if}}
  {{> @partial-block}}
</dt>
